export const refs = {
    logo: document.querySelector('.js-logo__link'),
    homePage: document.querySelector('[data-homePage]'),
    heroSection:document.querySelector('.js-hero__section'),
    heroContainer: document.querySelector('.js-hero__container'),
    headerNav: document.querySelector('.js-header-nav'),
    headerNavLinks: document.querySelectorAll('.js-header-nav__link'),
    searchInputWrapp: document.querySelector('.js-search__wrapp'),
    searchInput: document.querySelector('[name="movieSearch"]'),
    searchInfo: document.querySelector('.js-hero__info'),
    libraryButtons: document.querySelector('.js-library__button-wrapp'),
    movieGallery: document.querySelector('.js-gallery'),
    changedElementsToOpenLibrary: document.querySelectorAll('[data-library]'),
    workerList: document.querySelector('.worker__list'),
    libraryBtn: document.querySelector('[data-libraryPage]'),
    watchedBtn: document.querySelector('.watched-btn'),
    removeBtn: document.querySelector('.remove-btn'),
    queueBtn: document.querySelector(".queue-btn"),
    clearList: document.querySelector(".clear-list-btn"),
    clearAllBtn: document.querySelector(".clear-all-btn"),
    body: document.querySelector('body'),
    paginationList:document.querySelector('.pagination'),
    paginationListLibrary: document.querySelector('.pagination.pagination__library'),
    mainSection: document.querySelector('.mainPage__section'),
}